/*
class ExtendedToggle {
  constructor($element) {
    this.$element = $($element);

    this.state = {
        isOpen: false
    };

    // this.expandIcon = this.$element.data("expandIcon") ?? "/static/images/icons.svg#plus-usage";
    // this.minimizeIcon = this.$element.data("minimizeIcon") ?? "/static/images/icons.svg#minus-usage";
  }

  init = () => {
    this.checkboxEl = this.$element.find(":checkbox");
    this.toggleEl = this.$element.find(".extended-toggle__read-more-icon");
    // this.expandableEl = this.$element.find(".extended-toggle__read-more--expandable");
    this.updateActiveState();

    this.toggleEl.on('click', this.onToggleClick);
  }

  onToggleClick = () => {
    this.state.isOpen = !this.state.isOpen
    this.updateActiveState();
  }

  updateActiveState = () => {
    if(this.state.isOpen)
    {
      this.$element.addClass("extended-toggle--expanded");
    } else {
      this.$element.removeClass("extended-toggle--expanded");
    }

    // Force repaint for browsers that lack common sence... ex safari...
    var repaintHack = this.toggleEl[0];
    repaintHack.style.display="none";
    repaintHack.offsetHeight;
    repaintHack.style.display="block";
  }
}
*/
const init = () => {
  // const $elements = $('[data-extended-toggle]');
  // $elements.each((i, el) => new ExtendedToggle(el).init());
}

export default init;
